
import Vue from 'vue'
import Button from './Button.vue'
import { mapGetters } from 'vuex'
import { ProjectPath } from '../channel.types'

export default Vue.extend({
  props: {
    path: Object,
  },

  methods: {
    triggerFavorite() {
      this.$store.dispatch('handle_favorite_click', this.path)
    },
    triggerShare() {
      this.$store.dispatch('track_share_click', this.path)
    },
  },

  computed: {
    ...mapGetters({
      _isFavorite: 'isFavorite',
    }),
    isFavorite() {
      return this._isFavorite(this.path)
    },
  },
  components: {
    Button,
  },
})
